const Close = () => (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.62646 1.375L1.37646 6.625" stroke="#202020" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M1.37646 1.375L6.62646 6.625" stroke="#202020" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>  
);

export default Close;

